// extracted by mini-css-extract-plugin
export var block = "site-branding-module--block--1UJ-_";
export var siteLogo = "site-branding-module--siteLogo--28PAM";